// library imports
import React from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider, message, notification } from "antd";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// style imports
import "./styles/index.css";
// config imports
import { CONFIGS } from "./configs/configs";
// context imports
import { IndexContext } from "./context/IndexContext";
// hook imports
import useThemeSwitcher from "./hooks/useThemeSwitcher";
// component/page imports
import MainLayout from "./layout/MainLayout";
import LoginPage from "./pages/login/LoginPage";
import UserProfilePage from "./pages/account/UserProfilePage";
import ChangePassword from "./pages/account/ChangePassword";
import HomePage from "./pages/home/HomePage";
import TransactionPage from "./pages/transaction/TransactionPage";
import ConfigurationFood from "./pages/configuration/ConfigurationFood";

const App = () => {
  // load theme switcher
  const [appTheme, updateTheme, isLightTheme] = useThemeSwitcher();

  // for triggering message
  const [messageApi, messageApiContext] = message.useMessage();

  // for triggering notification
  const [notificationApi, notificationApiContext] =
    notification.useNotification();

  return (
    <ConfigProvider theme={{ ...appTheme }}>
      {messageApiContext}
      {notificationApiContext}
      <IndexContext.Provider
        value={{
          messageApi: messageApi,
          notificationApi: notificationApi,
          isLightTheme: isLightTheme,
          updateTheme: updateTheme,
        }}
      >
        <BrowserRouter basename={CONFIGS.route_basename}>
          <Routes>
            {/* Login Route */}
            <Route path="login" element={<LoginPage />}></Route>
            {/* All content pages */}
            <Route element={<MainLayout updateTheme={updateTheme} />}>
              <Route path="Home" element={<HomePage />}></Route>
              <Route path="Transaction" element={<TransactionPage />}></Route>
              <Route path="Configuration">
                <Route
                  path="Configuration_Food"
                  element={<ConfigurationFood />}
                ></Route>
              </Route>
              {/* Sub route for Account */}
              <Route path="Account">
                <Route path="UserProfile" element={<UserProfilePage />}></Route>
                <Route
                  path="ChangePassword"
                  element={<ChangePassword />}
                ></Route>
              </Route>
            </Route>
            {/* Default all unknown route to login page */}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </BrowserRouter>
      </IndexContext.Provider>
    </ConfigProvider>
  );
};

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
